/**
 * Historique des imports de paiements.
 */
import React from 'react';
import { useListImportsQuery } from '../../services/portailAdminApi';

function formatMoney(s: string): string {
  const n = parseFloat(s);
  if (isNaN(n)) return s;
  return new Intl.NumberFormat('fr-FR').format(n) + ' FCFA';
}

function formatDate(s: string): string {
  return new Date(s).toLocaleString('fr-FR');
}

export const HistoriqueImports: React.FC = () => {
  const { data, isLoading } = useListImportsQuery();
  const items = data?.results || [];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
          {isLoading ? 'Chargement...' : `${items.length} imports effectués`}
        </h3>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-900">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Date</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Période</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Fichier</th>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Par</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Étudiants</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">À jour</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">En dette</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">Total dû</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {items.map((i) => (
              <tr key={i.id}>
                <td className="px-3 py-2 text-sm text-gray-700 dark:text-gray-300">{formatDate(i.date_import)}</td>
                <td className="px-3 py-2 text-sm">
                  <span className="px-2 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 rounded text-xs font-medium">
                    {i.periode}
                  </span>
                </td>
                <td className="px-3 py-2 text-sm text-gray-700 dark:text-gray-300 max-w-xs truncate" title={i.fichier_nom}>
                  {i.fichier_nom}
                </td>
                <td className="px-3 py-2 text-sm text-gray-700 dark:text-gray-300">{i.importe_par_nom || '—'}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-900 dark:text-gray-100 font-medium">{i.nb_etudiants}</td>
                <td className="px-3 py-2 text-sm text-right text-green-700 dark:text-green-400">{i.nb_a_jour}</td>
                <td className="px-3 py-2 text-sm text-right text-red-700 dark:text-red-400">{i.nb_en_dette}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-900 dark:text-gray-100">{formatMoney(i.total_du)}</td>
              </tr>
            ))}
            {items.length === 0 && !isLoading && (
              <tr>
                <td colSpan={8} className="px-4 py-8 text-center text-gray-500 dark:text-gray-400 text-sm">
                  Aucun import effectué pour le moment.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
